import group from "../../assets/JoinNow/group.svg";
import { useTranslation } from "react-i18next";

const ImageSideUI = () => {
  const { t } = useTranslation();

  return (
    <div className="lg:w-[73.30rem] lg:h-[42rem] hidden lg:block md:block lg:top-[9.69rem] lg:left-[16.75rem] md:w-[24rem] md:h-[33rem] lg:py-8 lg:px-8 md:py-8 md:px-8 ">
      <div className="text-[rgb(5,110,156)] font-poppins lg:text-2xl md:text-base font-semibold  ">
        <div className="lg:h-[2rem] lg:w-[29rem]  md:h-[1.50rem] md:w-[15.50rem] flex items-center ">
          {t("join.now.rewards")}
        </div>
        <div className="lg:h-[2rem] lg:w-[29rem]   md:h-[1.50rem] md:w-[15rem] flex items-center ">
          {" "}
          {t("join.now.opinions")}{" "}
        </div>
      </div>
      <div className=" flex flex-col gap-3 lg:mt-8 md:mt-4">
        <div className="flex items-center gap-2 font-poppins font-normal lg:text-base md:text-xs">
          <div className="rounded-full lg:h-5 lg:w-5 md:h-4 md:w-4 bg-[#056E9C24] flex items-center justify-center">
            <div className="lg:w-[0.88rem] lg:h-[0.88rem]  md:w-[0.70rem] md:h-[0.70rem] rounded-full bg-[#056E9C]"></div>
          </div>
          <div>{t("join.now.Card")}</div>
        </div>
        <div className="flex items-center gap-2 font-poppins font-normal lg:text-base md:text-xs">
          <div className="rounded-full lg:h-5 lg:w-5 md:h-4 md:w-4 bg-[#056E9C24] flex items-center justify-center">
            <div className="lg:w-[0.88rem] lg:h-[0.88rem]  md:w-[0.70rem] md:h-[0.70rem] rounded-full bg-[#056E9C]"></div>
          </div>
          <div>{t("join.now.Anytime")}</div>
        </div>
        <div className="flex items-center gap-2 font-poppins font-normal lg:text-base md:text-xs">
          <div className="rounded-full lg:h-5 lg:w-5 md:h-4 md:w-4 bg-[#056E9C24] flex items-center justify-center">
            <div className="lg:w-[0.88rem] lg:h-[0.88rem]  md:w-[0.70rem] md:h-[0.70rem] rounded-full bg-[#056E9C]"></div>
          </div>
          <div>{t("join.now.Contribute")}</div>
        </div>
        <div className="flex items-center gap-2 font-poppins font-normal lg:text-base md:text-xs">
          <div className="rounded-full lg:h-5 lg:w-5 md:h-4 md:w-4 bg-[#056E9C24] flex items-center justify-center">
            <div className="lg:w-[0.88rem] lg:h-[0.88rem]  md:w-[0.70rem] md:h-[0.70rem] rounded-full bg-[#056E9C]"></div>
          </div>
          <div>{t("join.now.Confidential")}</div>
        </div>
      </div>
      <div className="lg:mt-10 md:mt-16 lg:w-[27rem] md:w-[19rem]">
        <img src={group} alt="" />
      </div>
    </div>
  );
};

export default ImageSideUI;